import { Meta } from "./base";
import { Reference } from "./reference";

export enum NotificationType {
  APPOINTMENT = "APPOINTMENT",
  SYSTEM = "SYSTEM",
  DATA_UPDATE = "DATA_UPDATE",
  ENCOUNTER = "ENCOUNTER",
  MEDICAL_RECORD = "MEDICAL_RECORD",
  MESSAGE = "MESSAGE",
}

export interface UserNotification {
  _id?: string;
  id: string;
  user: Reference;
  organization: Reference;
  type: NotificationType;
  title: string;
  message: string;
  data?: Record<string, any>;
  read: boolean;
  readAt?: string;
  meta: Meta;
  expiresAt?: string;
  sourceService: string;
}

export interface NotificationQuery {
  userId?: string;
  type?: NotificationType;
  read?: boolean;
  limit?: number;
  offset?: number;
}

export interface NotificationCountsResponse {
  total: number;
  read: number;
  unread: number;
}
